import ReactTooltip from 'react-tooltip';
import React, { useEffect, useState, useMemo, useRef } from "react"
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import styles from "./index.module.css";
import LoadingModal from './Unit/LoadingModal';

const conversionCode = [
  {
    id:'4125334224444393',
    name: 'HN'
  },
  {
    id:'1867147087259470',
    name: 'PP'
  },
  {
    id:'1659476788364547',
    name: 'HCM'
  },
  {
    id:'1571250584058206',
    name: 'DN'
  },
  {
    id:'850834341185625',
    name: 'HP'
  }
]
export default function GoogleAds({ itemsPerPage = 5}) {
     const {t} = useTranslation()
     const [isLoading, setIsLoading] = useState(false)
     const [filteredAdsData, setFilteredAdsData] = useState([]);
     const [startDate, setStartDate] = useState(() => dayjs().startOf("month").format("YYYY-MM-DD") );
     const [endDate, setEndDate] = useState(() => dayjs().endOf("month").format("YYYY-MM-DD") );
     const currentYear = dayjs().year();
     const [selectedMonth, setSelectedMonth] = useState(dayjs().month() + 1); 
     const [selectedYear, setSelectedYear] = useState(currentYear);
     const [adsData, setAdsData] = useState([]);
     const [adsSubData, setAdsSubData] = useState([]);
     const [imageData, setImageData] = useState()
     const [sortType, setSortType] = useState("");
     const [sortRankType, setSortRankType] = useState("");
     const [resource, setResource] = useState("");
     const [hoverImg, setHoverImg] = useState()

    useEffect(() => {
      setIsLoading(true)
      setTimeout(() => {
        setIsLoading(false)
      }, 10000)
    }, [selectedMonth, selectedYear])


    const getMetaAdsData = async () => {
      try {
        setIsLoading(true);
        const res = await fetch(`/api/meta/data/${startDate}/${endDate}`);

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await res.json();

        if (responseData) {
          setAdsData(responseData?.data ? { data: responseData.data } : { data: [] });
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setIsLoading(false);
      }
    }
    const getMetaAdsSubData = async () => {
        try {
          const response = await fetch(`/api/meta/sub-data`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
        const responseData = await response.json();
          if(responseData){
            setAdsSubData(responseData)
          }
        } catch (error) {
          console.error('Error:', error);
      }
      }
    const getImageData = async () => {
        try {
          const response = await fetch(`/api/meta/image-data`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
        const responseData = await response.json();
          if(responseData){
            setImageData(responseData)
          }
        } catch (error) {
          console.error('Error:', error);
      }
      }
      useEffect(() => {
      if (!selectedMonth || !selectedYear) return;

      const date = dayjs(`${selectedYear}-${selectedMonth}-01`);
      setStartDate(date.startOf("month").format("YYYY-MM-DD"));
      setEndDate(date.endOf("month").format("YYYY-MM-DD"));
}, [selectedMonth, selectedYear]);
    useEffect(() => {
    if (!startDate || !endDate) return;

    setIsLoading(true);

    Promise.all([
      getMetaAdsSubData(),
      getMetaAdsData(),
      getImageData()
    ]).finally(() => {
      setIsLoading(false);
    });

  }, [startDate, endDate]);


      const updateDateByMonthYear = (month, year) => {
        const date = dayjs(`${year}-${month}-01`);

        setStartDate(date.startOf("month").format("YYYY-MM-DD"));
        setEndDate(date.endOf("month").format("YYYY-MM-DD"));
      };
      const handleMonthChange = (e) => {
        const month = Number(e.target.value);
        setSelectedMonth(month);
        updateDateByMonthYear(month, selectedYear);
      };

      const handleYearChange = (e) => {
        const year = Number(e.target.value);
        setSelectedYear(year);
        updateDateByMonthYear(selectedMonth, year);
      };
    function mergeCampaignInsightWithStatus(adsSubData, adsData) {
      if (!adsSubData?.data || !adsData?.data) return [];

      const campaignStatusMap = Object.fromEntries(
        adsSubData?.data?.map(item => [
          item.id,
          {
            status: item.status,
            effective_status: item.effective_status,
            name: item.name,
            creative: item.creative,
            image_url: item.image_url,
            thumbnail_url: item.thumbnail_url
          }
        ])
      );

  return adsData?.data?.reduce((acc, row) => {
   const adId = row.ad_id
    if (!adId) return acc;
     if (!acc[adId]) acc[adId] = [];
    const impressions = Number(row.impressions || 0);
    const clicks = Number(row.clicks || 0);
    const spend = Number(row.spend || 0);
    

    acc[adId].push({
       ad_id: row.ad_id,
       campaign_id: row.campaign_id,
       campaign_name: row.campaign_name,
       conversion_rate_ranking: row.conversion_rate_ranking,
       optimization_goal: row.optimization_goal,
       reach: row.reach,
       frequency: row.frequency,
       actions: row.actions,
       cost_per_action_type: row.cost_per_action_type,
       quality_ranking: row.quality_ranking,
       date_start: row.date_start,
       date_stop: row.date_stop,
       impressions,
       clicks,
       spend,
       ctr: impressions ? ((clicks / impressions) * 100).toFixed(2) + "%" : "0%",
       status:
         campaignStatusMap[row.ad_id]?.status || "UNKNOWN",
       effective_status:
         campaignStatusMap[row.ad_id]?.effective_status || "UNKNOWN",
        creative: campaignStatusMap[row.ad_id]?.creative,
        image_url: campaignStatusMap[row.ad_id]?.image_url,
        thumbnail_url: campaignStatusMap[row.ad_id]?.thumbnail_url
      })

    return acc;
  },{});
}

 useEffect(() => {
    if (!adsData?.data?.length || !adsSubData?.data?.length) return;
    const filtered = mergeCampaignInsightWithStatus(adsSubData, adsData)
    setFilteredAdsData(filtered)
    
  }, [adsData, adsSubData])
  
  const sortedData = useMemo(() => {
   const campaignData = filteredAdsData?.[resource] ?? [];

   if (!Array.isArray(campaignData)) return [];

  let temp = [...campaignData];

    switch (sortType) {
      case "clicks-asc":
        temp.sort(
          (a, b) => Number(a.clicks) - Number(b.clicks)
        );
        break;

      case "clicks-desc":
        temp.sort(
          (a, b) => Number(b.clicks) - Number(a.clicks)
        );
        break;

      case "impressions-asc":
        temp.sort(
          (a, b) => Number(a.impressions) - Number(b.impressions)
        );
        break;

      case "impressions-desc":
        temp.sort(
          (a, b) => Number(b.impressions) - Number(a.impressions)
        );
        break;

      case "cost-asc":
        temp.sort(
          (a, b) =>
            Number(a.costMicros) - Number(b.costMicros)
        );
        break;

      case "cost-desc":
        temp.sort(
          (a, b) =>
            Number(b.costMicros) - Number(a.costMicros)
        );
        break;
          case "conversions-asc":
        temp.sort(
          (a, b) =>
            Number(a.conversions) - Number(b.conversions)
        );
        break;

      case "conversions-desc":
        temp.sort(
          (a, b) =>
            Number(b.conversions) - Number(a.conversions)
        );
        break;
         case "cpc-asc":
        temp.sort((a, b) => {
            const cpcA =
              Number(a.clicks) > 0
                ? Number(a.costMicros) / 1_000_000 / Number(a.clicks)
                : 0;

            const cpcB =
              Number(b.clicks) > 0
                ? Number(b.costMicros) / 1_000_000 / Number(b.clicks)
                : 0;

            return cpcA - cpcB;
          });
          break;
      case "cpc-desc":
        temp.sort((a, b) => {
            const cpcA =
              Number(a.clicks) > 0
                ? Number(a.costMicros) / 1_000_000 / Number(a.clicks)
                : 0;

            const cpcB =
              Number(b.clicks) > 0
                ? Number(b.costMicros) / 1_000_000 / Number(b.clicks)
                : 0;

            return cpcB - cpcA;
          });
          break;

      case "name-asc":
        temp.sort((a, b) =>
          a.campaign_name.localeCompare(b.campaign_name)
        );
        break;

      case "name-desc":
        temp.sort((a, b) =>
          b.campaign_name.localeCompare(a.campaign_name)
        );
        break;
        default:
    }   

    return temp;
  }, [sortType, filteredAdsData, resource]);
  
useEffect(() => {
  if (!resource && filteredAdsData) {
    const firstActive = Object.entries(filteredAdsData)
      .find(([_, rows]) => rows?.[0]?.effective_status === "ACTIVE");

    if (firstActive) {
      setResource(firstActive[0]);
    }
  }
}, [filteredAdsData, resource]);

  const campaignStats = adsData?.data?.reduce((acc, row) => {
    const campaignId = row.campaign_id;
    const adId = row.ad_id;
    const campaignName = row.campaign_name;
    const campaignAction = (row?.actions ?? [])
    .filter(item => item?.action_type?.startsWith("offsite_conversion.custom.") || item?.action_type === "onsite_conversion.messaging_welcome_message_view")

    const campaignConversion = (row.actions ?? [])
    .filter(item => item.action_type?.startsWith("offsite_conversion.custom."))
    .reduce((sum, item) => sum + Number(item.value ?? 0), 0);
    
    // const frequencyAds = row.reach > 0 ? row.impressions / row.reach : 0
    if (!acc[campaignId]) {
      acc[campaignId] = {
        campaignId,
        campaignName,
        adId,
        spend: 0,
        impressions: 0,
        clicks: 0,
        reach: 0,
        // frequency: 0,
        campaignConversion,
        campaignAction: []
      };
    }

    acc[campaignId].impressions += Number(row.impressions || 0);
    // acc[campaignId].frequency += Number
    acc[campaignId].reach += Number(row.reach || 0);
    acc[campaignId].clicks += Number(row.clicks || 0);
    acc[campaignId].spend += Number(row.spend || 0);
    acc[campaignId].campaignConversion += campaignConversion
    acc[campaignId].campaignAction.push(...campaignAction);

    return acc;
  }, {}) || {};

    
  const tableData = Object.values(campaignStats || {}).map(item => {
    const ctr = item.impressions
      ? (item.clicks / item.impressions) * 100
      : 0;
    return {
      campaignId: item.campaignId,
      adId: item.adId,
      campaign: item.campaignName,
      impressions: item.impressions,
      clicks: item.clicks,
      ctr: ctr.toFixed(2) + "%",
      conversions: item.campaignConversion,
      cost: item.campaignCost,
      actions: item.campaignAction,
      spend: item.spend,
      cpa: item.campaignConversion > 0 && item.spend > 0 ? (item.spend / item.campaignConversion) : 0,
      reach: item.reach,
    };
  });
   
  const sortedRankData = useMemo(() => {
     if (!Array.isArray(tableData)) return [];
  
    let temp = [...tableData];
  
      switch (sortType) {
        case "clicks-asc":
          temp.sort(
            (a, b) => Number(a.clicks) - Number(b.clicks)
          );
          break;
  
        case "clicks-desc":
          temp.sort(
            (a, b) => Number(b.clicks) - Number(a.clicks)
          );
          break;
  
        case "impressions-asc":
          temp.sort(
            (a, b) => Number(a.impressions) - Number(b.impressions)
          );
          break;
  
        case "impressions-desc":
          temp.sort(
            (a, b) => Number(b.impressions) - Number(a.impressions)
          );
          break;
  
        case "cost-asc":
          temp.sort(
            (a, b) =>
              Number(a.cost) - Number(b.cost)
          );
          break;
  
        case "cost-desc":
          temp.sort(
            (a, b) =>
              Number(b.cost) - Number(a.cost)
          );
          break;
            case "conversions-asc":
          temp.sort(
            (a, b) =>
              Number(a.conversions) - Number(b.conversions)
          );
          break;
  
        case "conversions-desc":
          temp.sort(
            (a, b) =>
              Number(b.conversions) - Number(a.conversions)
          );
          break;
          case "cpa-asc":
          temp.sort(
            (a, b) =>
              Number(a.cpa) - Number(b.cpa)
          );
          break;
  
        case "cpa-desc":
          temp.sort(
            (a, b) =>
              Number(b.cpa) - Number(a.cpa)
          );
          break;
            case "ctr-asc":
          temp.sort(
            (a, b) =>
              Number(a.ctr) - Number(b.ctr)
          );
          break;
  
        case "ctr-desc":
          temp.sort(
            (a, b) =>
              Number(b.ctr) - Number(a.ctr)
          );
          break;
          default: 
      }
  
      return temp;
    }, [sortRankType, tableData]); 

    const AdsSubDataMap = useMemo(() => {
      const map = {}
      adsSubData?.data?.forEach(item => {
        map[item.id] = item
      })
      return map;
    },[adsSubData])

    const ImageDataMap = useMemo(() => {
      const map = {}
      imageData?.data?.forEach(item => {
        map[item.hash] = item
      })
      return map;
    }, [imageData])

   const sortedRankDataByStatus = useMemo(() =>{
    if(!sortedRankData?.length) return []

    return [...sortedRankData].sort((a,b) => {
      const aStatus = AdsSubDataMap?.[a.adId]?.effective_status
      const bStatus = AdsSubDataMap?.[b.adId]?.effective_status

      if(aStatus === "ACTIVE" && bStatus !== "ACTIVE") return - 1
      if(aStatus !== "ACTIVE" && bStatus === "ACTIVE") return + 1
      return 0
    })
   }, [sortedRankData, AdsSubDataMap]) 

    useEffect(() => {
}, [sortedRankDataByStatus])
     const [currentPage, setCurrentPage] = useState(1);
     const totalPages = Math.ceil(sortedRankDataByStatus?.length / itemsPerPage);
     const currentData = sortedRankDataByStatus?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
     
  const goPrev = () => setCurrentPage(p => Math.max(p - 1, 1));
  const goNext = () => setCurrentPage(p => Math.min(p + 1, totalPages));
    return (
<div>
   <ReactTooltip id = 'marketing' style={{
                     fontSize: 20,
                     maxWidth: 400,
                     whiteSpace: "pre-line",
                     backgroundColor: "#000",
                     borderRadius: 10,
                     zIndex: 99999
                   }}/>
      {/* <MarketingHeader /> */}
     <div style={{ padding: 20, backgroundColor:"#fff" }}> 
        <div className="d-flex ml-3 align-items-center" style={{marginTop:50}}>
             <div style={{marginRight: 10, width: 'fit-content'}}>
                      <select className={styles.contentBookingBranchSelect} value={selectedYear} onChange={handleYearChange}>
                        {[...Array(5)].map((_, i) => {
                          const year = currentYear - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
               <div style={{marginRight: 10, width: 'fit-content'}}>
                      <div style={{ display: "flex", gap: "12px" }}>
                        <select className={styles.contentBookingBranchSelect} value={selectedMonth} onChange={handleMonthChange}>
                          {[...Array(12)].map((_, i) => (
                            <option key={i + 1} value={i + 1}>
                              Month {i + 1}
                            </option>
                          ))}
                        </select>
                            </div>
        </div>
          {/* <div style={{marginRight: 10, width: 'fit-content'}}>
            <button className={stylesBase.baseBtn}  onClick={() => getMetaAdsData()}>Refresh</button>
            </div>
             <div style={{marginRight: 10, width: 'fit-content'}}>
        <button className={stylesBase.baseBtn} onClick={getMetaAdsData}>Get Data</button>
            </div> */}
             </div>
    </div>
    {isLoading && (
          <LoadingModal />
        )}

          <div>
           <div className="d-flex align-items-center" style={{marginTop: 50}}>
            <img src="https://cdn-icons-png.flaticon.com/512/6033/6033716.png" alt="Meta" style={{width: 60, height: 60, marginLeft: 30}}/>
            <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Meta Ads Report</div>
                  </div>
               <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Overall</div>
               <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div style={paginationContainerStyle}>
                              <button
                                onClick={goPrev}
                                disabled={currentPage === 1}
                                style={{
                                  ...paginationBtnStyle,
                                  ...(currentPage === 1 && paginationBtnDisabledStyle),
                                }}
                              >
                                «
                              </button>

                              <span style={paginationTextStyle}>
                                Page {currentPage} / {totalPages}
                              </span>

                              <button
                                onClick={goNext}
                                disabled={currentPage === totalPages}
                                style={{
                                  ...paginationBtnStyle,
                                  ...(currentPage === totalPages &&
                                    paginationBtnDisabledStyle),
                                }}
                              >
                                »
                              </button>
                            </div>
                            <div className="mt-4" >
                          <table border="1" style={{ ...tableStyle }}>
                            <thead>
                              <tr>
                                <th style={{...thStyle, ...stickyHeader}}>No.</th>
                                <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.googleAds.campaignID')} data-for="marketing">Campaign ID</th>
                                <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.meta.creative')} data-for="marketing">Creative</th>
                                <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.googleAds.campaignName')} data-for="marketing">Campaign Name</th>
                                <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #4285F4 0%, #6EA8FF 100%)"}}>
                                <div className="d-flex justify-content-between align-items-center" data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                                    <span>Conversions</span>
                                    <div className="d-flex flex-column">
                                      <button
                                        className="btn-sort"
                                        onClick={() => setSortType("conversions-asc")}
                                        style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                                      >
                                        <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                                      </button>
                                      <button
                                        className="btn-sort"
                                        onClick={() => setSortType("conversions-desc")}
                                        style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                                      >
                                        <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                                      </button>
                                    </div>
                                  </div>
                                </th>
                                <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #DB4437 0%, #FF6B5E 100%)"}} data-tip={t('marketing.googleAds.impression')} data-for="marketing">Impression</th>
                                <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #F4B400 0%, #FFD95A 100%)"}} data-tip={t('marketing.googleAds.click')} data-for="marketing">Click</th>
                                <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #0F9D58 0%, #34C97B 100%)"}} data-tip={t('marketing.googleAds.cost')} data-for="marketing">Cost</th>
                                <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #AB47BC 0%, #D47BE3 100%)"}} data-tip={t('marketing.googleAds.cpa')} data-for="marketing">CPA</th>
                                <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #00ACC1 0%, #4DD9E8 100%)"}} data-tip={t('marketing.googleAds.ctr')} data-for="marketing">CTR</th>
                                <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #FB8C00 0%, #FFB347 100%)"}} data-tip={t('marketing.meta.reach')} data-for="marketing">Reach</th>
                                {/* <th style={{...thStyle, backgroundColor:'#FB8C00'}}>Frequency</th> */}
                                {/* <th style={{...thStyle, backgroundColor:'#FB8C00'}}>Spend</th> */}
                            </tr>
                            </thead>
                            <tbody>
                              {currentData
                              .map((row, idx) => {
                                const sub = AdsSubDataMap?.[row.adId]
                                const image1 = ImageDataMap?.[sub?.creative?.object_story_spec?.link_data?.child_attachments?.[0]?.image_hash]
                                const messagingStarted = (row?.actions ?? [])
                                .filter(item => item?.action_type === "onsite_conversion.messaging_welcome_message_view")
                                .reduce((sum, item) => sum + Number(item.value || 0), 0);
                                const checkSource = new Map();
                                (row.actions || []).forEach(item => {
                                const match = item.action_type?.match(/offsite_conversion\.custom\.(\d+)/);
                                if (!match) return;

                                const id = String(match[1]);
                                const value = Number(item.value || 0);

                                checkSource.set(id, (checkSource.get(id) || 0) + value);
                              });

                                const isSameId = conversionCode
                                .filter(item => checkSource.has(String(item.id)))
                                .map(item => ({
                                  id: item.id,
                                  name: item.name,
                                  value: checkSource.get(String(item.id))
                                }));
                                
                                return (
                                <tr key={idx}  style={{backgroundColor: idx % 2 === 0 ? "#fff" : "#E6E6E6"}}
                                >
                                  <td style={tdStyle}>{idx+1}</td>
                                  <td style={tdStyle}>{row.campaignId}</td>
                                  <td style={{...tdStyle, padding: 10, height:200, width: 200, position: 'relative'}} 
                                      onMouseEnter={(e) => setHoverImg({src: sub?.creative?.image_url || image1?.url || 'https://www.shutterstock.com/image-vector/missing-picture-page-website-design-600nw-1552421075.jpg', x: e.clientX, y: e.clientY})} 
                                      onMouseMove={(e) => setHoverImg((prev) => prev ? {...prev, x: e.clientX, y: e.clientY} : prev)}
                                      onMouseLeave={() => setHoverImg(null)}>
                                    <img alt = '' src={sub?.creative?.image_url || image1?.url || 'https://www.shutterstock.com/image-vector/missing-picture-page-website-design-600nw-1552421075.jpg'}  style={{height: 200, width: 200, cursor: 'pointer'}}/>
                                    {hoverImg && (
                                      <img alt = '' src={hoverImg.src} style={{position:'fixed', top: hoverImg.y + 12, left: hoverImg.x + 12, width: 600, zIndex: 999, pointerEvents: 'none', boxShadow: "0 6px 10px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)"}} />
                                    )}
                                  </td>
                                  <td style={{...tdStyle, textAlign: 'left'}}>
                                    <div className="d-flex justify-content-between">
                                    <div style={{color:sub?.effective_status === "ACTIVE" ? "#000" : "#ccc"}}>{row.campaign}</div>
                                    <div style={{borderRadius: 10, border: `3px solid ${sub?.effective_status === "ACTIVE" ? "#23C552" : "#F84F31"}`, paddingLeft: 5, paddingRight: 5, color: sub?.effective_status === "ACTIVE" ? "#23C552" : "#F84F31", fontWeight: 'bold'}}>{sub?.effective_status === "ACTIVE" ? "ACTIVE" : "CLOSED"}</div>
                                    </div>
                                  </td>
                                  <td style={tdStyle}>{row.conversions} <br />
                                  {isSameId.map(item => (
                                    <div key={item.id}>{item.name} ({item.value})</div>
                                  ))}
                                  <div>DM ({messagingStarted})</div>
                                  </td>
                                  <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.impressions)}</td>
                                  <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.clicks)}</td>
                                  <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.spend)}</td>
                                  <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.cpa)}</td>
                                  {/* <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.frequency)}</td> */}
                                  <td style={tdStyle}>{row.ctr}</td>
                                  <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.reach)}</td>

                                  {/* <td style={tdStyle}>{row.spend}</td> */}
                                </tr>
                                )
                            })}
                            </tbody>
                          </table>
                          </div>
                          </div>
                </div>
               </div>
               <div className="container-fluid pb-5">
                <div className="row">
                  <div className="col-md-12">
                     <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 10, marginTop: 10}}>Detail</div>
                       <div style={{marginRight: 10, width: 'fit-content'}}>
                            <select className={styles.contentBookingBranchSelect} value={resource} onChange={(e) => {
                                setResource(e.target.value)
                                }}>
                            {Object.entries(filteredAdsData)
                            .filter(([_, rows]) => rows?.[0]?.effective_status === "ACTIVE")
                            .map(([campaignId, rows]) => (
                                <option key={campaignId} value={campaignId}>
                                {rows[0]?.campaign_name}
                                </option>
                            ))}
                        </select>
                </div>
                    <div style={{ overflowX: "auto" }}>
                  <table style={tableStyle}>
                    <thead>
                      <tr>
                        <th style={thStyle}>No.</th>
                        <th style={thStyle}>Date</th>
                        <th style={thStyle} data-tip={t('marketing.googleAds.campaignID')} data-for="marketing">Campaign ID</th>
                        <th style={thStyle} data-tip={t('marketing.googleAds.campaignName')} data-for="marketing">Campaign Name</th>
                        <th style={{...thStyle, background:"linear-gradient(135deg, #4285F4 0%, #6EA8FF 100%)"}}>
                          <div className="d-flex justify-content-between align-items-center"  data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                            <span>Conversions</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                                 </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                         <th style={{...thStyle, background:"linear-gradient(135deg, #DB4437 0%, #FF6B5E 100%)"}}>
                          <div className="d-flex justify-content-between align-items-center"  data-tip={t('marketing.googleAds.impression')} data-for="marketing">
                            <span>Impressions</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("impressions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("impressions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                       <th style={{...thStyle, background:"linear-gradient(135deg, #F4B400 0%, #FFD95A 100%)"}}>
                          <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.click')} data-for="marketing">
                            <span>Clicks</span>
                            <div className="d-flex flex-column ml-1">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("clicks-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("clicks-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                         
                        <th style={{...thStyle, background:"linear-gradient(135deg, #0F9D58 0%, #34C97B 100%)"}}>
                           <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.cost')} data-for="marketing">
                            <span>Cost</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cost-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cost-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                        
                        {/* <th style={{...thStyle, backgroundColor:"#AB47BC"}}>
                           <div className="d-flex justify-content-between align-items-center">
                            <span>CPC</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cpc-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cpc-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                        <th style={{...thStyle, backgroundColor:"#00ACC1"}}>CPA</th>
                        <th style={{...thStyle, backgroundColor:"#FB8C00"}}>CTR</th>
                        <th style={{...thStyle, backgroundColor:"#5F6368"}}>CPM</th>
                  
                        <th style={thStyle}>Date</th>
                        <th style={thStyle}>Device</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {sortedData.map((row, idx) => {
                        const result = row.actions
                            ?.filter(a => a.action_type?.includes("offsite_conversion.custom."))
                            .reduce(
                              (acc, cur) => {
                                acc.count += 1;
                                acc.total += Number(cur.value || 0);
                                return acc;
                              },
                              { count: 0, total: 0 }
                            ) || { count: 0, total: 0 };
                          return (
                          <tr key={idx} style={{backgroundColor: idx % 2 === 0 ? "#fff" : "#E6E6E6"}} 
                          >
                            <td style={tdStyle}>{idx+1}</td>
                            <td style={tdStyle}>{row.date_stop}</td>
                            <td style={tdStyle}>{row.campaign_id}</td>
                            <td style={tdStyle}>{row.campaign_name} </td>
                            <td style={tdStyle}>{result.total}</td>
                            <td style={tdStyle}>{row.clicks}</td>
                            <td style={tdStyle}>{row.impressions}</td>
                            <td style={tdStyle}>{Intl.NumberFormat("de-DE").format((row.spend))}đ</td>
                          </tr>
                          )
                        })
                    }
                    </tbody>
                  </table>
                </div>                 
              </div>
                </div>
               </div>
         </div> 
    </div>
  );
}

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  borderRadius: 16,
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
  backgroundColor: "#fff",
  tableLayout: "auto",
  marginTop: 10
};
const thStyle = {
  padding: "14px 16px",
  textAlign: "center",
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  letterSpacing: "0.5px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
};

const tdStyle = {
  padding: "12px 14px",
  textAlign: "center",
  border: "1px solid #e5e7eb",
  fontSize: 18,
  color: "#333",
  backgroundColor: "#fff",
  cursor: "pointer",
  whiteSpace: "nowrap", 
};
const stickyHeader = {
  fontSize: 16,
  position: 'sticky',top: 80,
  zIndex: 999
};
const stickyHeader2 = {
  fontSize: 16,
  position: 'sticky',top: 90,
  zIndex: 999
};
const paginationContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 14,
  width: "fit-content",
  marginTop: 20,
  padding: "10px 16px",
  borderRadius: 16,
  background: "#fff",
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
};

const paginationBtnStyle = {
  height: 42,
  width: 42,
  border: "none",
  borderRadius: 12,
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.25s ease",
  boxShadow: "0 4px 10px rgba(108, 74, 182, 0.25)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const paginationBtnDisabledStyle = {
  background: "#f3f4f6",
  color: "#9ca3af",
  cursor: "not-allowed",
  boxShadow: "none",
};

const paginationTextStyle = {
  fontSize: 16,
  fontWeight: 600,
  color: "#482979",
  whiteSpace: "nowrap",
};




